var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{attrs:{"align":"center"}},[(_vm.src)?_c('img',{staticClass:"img-cover-radius",attrs:{"height":"50","width":"50","src":_vm.src,"alt":""}}):_c('img',{staticClass:"pointer",attrs:{"height":"40","width":"40","src":require("@/assets/images/playground/ban.svg"),"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }